import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { getDatabase, ref, onValue, set } from "firebase/database";
import { useParams } from "react-router-dom";
import winnerScreenBg from "../../image/App-BG.png";
import "../../style/PlayerWinnerParticipant.css";  // Import external CSS
import outer from '../../image/WinnerScreenParticipantSide/SURVEY_SLACK_SOCIAL_MEDIA_POST_1.png';
import { backgroundImages } from "polished";
import first from '../../image/WinnerScreenParticipantSide/star1.png';
import second from '../../image/WinnerScreenParticipantSide/star2.png';
import third from '../../image/WinnerScreenParticipantSide/star3.png';
import NoSleep from "nosleep.js"; 
import gifStarFirst from '../../image/WinnerScreenParticipantSide/gif_1.gif';
import gifstarsecond from '../../image/WinnerScreenParticipantSide/gif2.gif';



const PlayerWinnerParticipant = ({ onNavigate, code: propCode }) => {
    const { code: urlCode } = useParams();
    const { slug } = useParams();
    const code = propCode || urlCode;
    const allocatedTeam = localStorage.getItem('allocatedTeam');
    const allocatedTeamColor = localStorage.getItem('allocatedTeamColor');
    const [gameName, setGameName] = useState('');
    const [winningTeam, setWinningTeam] = useState('');
    const [resultText, setResultText] = useState('');
    const [point, setPoint] = useState('');
    const [topParticipants, setTopParticipants] = useState([]);
    const [participants, setParticipants] = useState([]);
    const [topScores, setTopScores] = useState([]);
    const noSleep = new NoSleep();

    useEffect(() => {
        if (code) {
   
            handleFirebaseUpdatebycode();
          }else{
            handleFirebaseUpdatebyslug(); 
          }
  }, [code]);
  

  const handleFirebaseUpdatebycode = () => {
    const database = getDatabase();
    const refPath = ref(database, `AppleTV/${code}`);
    let previousData;

    onValue(refPath, (snapshot) => {
        const data = snapshot.val();
        if (data !== previousData) {
            previousData = data;

            const command = data.command;
            if (command === '7010') {
                setGameName(data.gameName || "Game Name");
                setWinningTeam(data.winningTeam || "");

                const result = data.resultText || "You won with 0 points!";
                setResultText(result);

                const pointMatch = result.match(/\d+/);
                setPoint(pointMatch ? pointMatch[0] : "0");

                // Use the winning team directly from the data
                const winningTeam = data.winningTeam;

                // Filter team members whose allocatedTeam matches the winning team.
                const allocatedTeamNames = data.teamNames
                .filter((participant) => participant.allocatedTeam === winningTeam)
                .map((participant) => participant.name);
            
            console.log("Filtered allocatedTeamNames:", allocatedTeamNames);
                console.log("Snapshot data:", data);
                console.log("Team names:", data.teamNames);
                console.log("Scores:", data.scores);
                
                // Find scores for the filtered participants and sort them by score.
                const teamScores = allocatedTeamNames.map((name) => ({
                  name,
                  score: data.scores[name]?.score || 0
              })).sort((a, b) => b.score - a.score);
                
                console.log("Filtered and sorted teamScores:", teamScores);

                // Update the winners list based on sorted scores
                setTopScores(teamScores.slice(0, 3)); // Take top 3 or less based on availability
            }
            const teamParticipants = data.teamNames.map((team) => {
              const participantScore = data.scores?.[team.name]?.score ?? 0;
              return {
                initials: team.initials,
                name: team.name,
                profileColor: team.profileColor,
                score: participantScore,
                animate: data.scores?.[team.name]?.animate ?? false,
              };
            });
  
            teamParticipants.sort((a, b) => b.score - a.score);
  
          
  
            setParticipants(teamParticipants);

            if (data.command === '7020') {
                const keysToRemove = [
                  'wordToGuess', 'guessedLetters', 'wrongGuesses', 'currentTeam', 'score',
                  'currentScreen', 'roundWinners', 'selectedRound', 'startTime', 'allocatedTeam',
                  'allocatedTeamColor', 'currentScreenParticipantside', 'initials', 'name', 'profileColor', 'code'
                ];
              
                keysToRemove.forEach((key) => window.localStorage.removeItem(key));
              
                // Wait a bit before redirecting
                setTimeout(() => {
                  console.log('Redirecting after clearing localStorage...');
                  window.location.href = 'https://play.triviamaker.com/';
                }, 100); // Adjust delay if needed
              }
              
              
        }
    });
  }
  const handleFirebaseUpdatebyslug = () => {
    const database = getDatabase();
    const refPath = ref(database, `AppleTV/${slug}`);
    let previousData;

    onValue(refPath, (snapshot) => {
        const data = snapshot.val();
        if (data !== previousData) {
            previousData = data;

            const command = data.command;
            if (command === '7010') {
                setGameName(data.gameName || "Game Name");
                setWinningTeam(data.winningTeam || "");

                const result = data.resultText || "You won with 0 points!";
                setResultText(result);

                const pointMatch = result.match(/\d+/);
                setPoint(pointMatch ? pointMatch[0] : "0");

                // Use the winning team directly from the data
                const winningTeam = data.winningTeam;

                // Filter team members whose allocatedTeam matches the winning team.
                const allocatedTeamNames = data.teamNames
                .filter((participant) => participant.allocatedTeam === winningTeam)
                .map((participant) => participant.name);
            
            console.log("Filtered allocatedTeamNames:", allocatedTeamNames);
                console.log("Snapshot data:", data);
                console.log("Team names:", data.teamNames);
                console.log("Scores:", data.scores);
                
                // Find scores for the filtered participants and sort them by score.
                const teamScores = allocatedTeamNames.map((name) => ({
                  name,
                  score: data.scores[name]?.score || 0
              })).sort((a, b) => b.score - a.score);
                
                console.log("Filtered and sorted teamScores:", teamScores);

                // Update the winners list based on sorted scores
                setTopScores(teamScores.slice(0, 3)); // Take top 3 or less based on availability
            }
            const teamParticipants = data.teamNames.map((team) => {
              const participantScore = data.scores?.[team.name]?.score ?? 0;
              return {
                initials: team.initials,
                name: team.name,
                profileColor: team.profileColor,
                score: participantScore,
                animate: data.scores?.[team.name]?.animate ?? false,
              };
            });
  
            teamParticipants.sort((a, b) => b.score - a.score);
  
          
  
            setParticipants(teamParticipants);

            if (data.command === '7020') {
                const keysToRemove = [
                  'wordToGuess', 'guessedLetters', 'wrongGuesses', 'currentTeam', 'score',
                  'currentScreen', 'roundWinners', 'selectedRound', 'startTime', 'allocatedTeam',
                  'allocatedTeamColor', 'currentScreenParticipantside', 'initials', 'name', 'profileColor', 'code'
                ];
              
                // Clear local storage
                keysToRemove.forEach((key) => {
                  window.localStorage.removeItem(key);
                });
              
                // Use a short timeout to ensure localStorage operations finish before redirecting
                setTimeout(() => {
                  window.location.href = 'https://play.triviamaker.com/';
                }, 0);
              }
        }
    });
  }

    return (
        <Container fluid className="vh-100 d-flex flex-column p-0 position-relative">
 

            <Row className="h-100 g-0">
                <Col className="bg-left-right flex-grow-1 flex-shrink-1" />
                <Col
                    xs={12}
                    sm={10}
                    md={8}
                    lg={6}
                    xl={4}
                    className="runneruphidecss flex-shrink-0"
                >
                    <div
                        className="winnerBgImg"
                     
                    >
                        <div className="text-center ">
                            <h2 id="gametielid">{winningTeam} Won With</h2>
                        </div>
                        <img src={gifstarsecond} alt="First Star" className="firstStar" />
                        <img src={gifStarFirst} alt="second Star" className="secondStar" />
                        <div
  className="winner-info text-center"
  style={{ 
    backgroundImage: `url(${outer})`, 
    backgroundSize: 'cover', 
    backgroundPosition: 'center', 
    backgroundRepeat: 'no-repeat',
    padding: '20px', // Optional: adds padding
    borderRadius: '10px' // Optional: rounded corners
  }}
>
                            <h1 className="point mb-4">{point}</h1>
                          

                            <p className="mt-2">Point(S)</p>
                        </div>
                   
                        <div id="morewinnerdiv">
                            <span id="moretext">less</span>
                        </div>
                         {/* <div id="basicchartdivid" className="basicscoreboardwinnerscreencss">
                       
                            <ul id="winnerscreenusersid" className="winnerscreen-list">
                            {topScores.map((participant, index) => (
                                <li key={participant.name} className="winnerscreen-item">
                                    <div className="winnerscreen-content">
                                        <div className="winnerscreen-left">
                                            <img
                                                src={
                                                    index === 0 ? first
                                                    : index === 1 ? second
                                                    : third
                                                }
                                                alt={`Trophy ${index + 1}`}
                                            />
                                        </div>
                                        <div className="teamanimalnameWinnerscreen">
                                            <span className="animalscreenlabelWinnerscreen">{participant.name}</span>
                                        </div>
                                        <div className="winnerscreen-right">
                                            <span className="winnerscreen-score">{participant.score}</span>
                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                          </div>   */}

<div id="basicchartdivid" className="basicscoreboardwinnerscreencss">
    <ul id="winnerscreenusersid" className="winnerscreen-list mt-3">
        {resultText.toLowerCase().includes("tie") || resultText === "You won with 0 points!"? (
            // If the resultText mentions "tie", show the draw message
            participants.map((participant, index) => (
                <li
                    key={index}
                    className="leaderboard-item "
                    style={{ top: `${index * 68}px` }}
                >
                    <div className="leaderboard-content">
                        <div className="leaderboard-left">
                            <span
                                className="animallistcircle"
                                style={{
                                    background: participant.profileColor,
                                    color: "white",
                                }}
                            >
                                {participant.initials}
                            </span>
                        </div>
                        <div className="teamanimalname" style={{textAlign:'justify'}}>
                            <span className="animalscreenlabel">{participant.name}</span>
                        </div>
                        <div className="leaderboard-right">
                            <span className="leaderboard-score">{participant.score}</span>
                        </div>
                    </div>
                </li>
            ))
        ) : (
            // Otherwise, display the sorted participant scores
            topScores.map((participant, index) => (
                <li key={participant.name} className="winnerscreen-item">
                    <div className="winnerscreen-content">
                        <div className="winnerscreen-left">
                            <img
                                src={
                                    index === 0
                                        ? first
                                        : index === 1
                                        ? second
                                        : third
                                }
                                alt={`Trophy ${index + 1}`}
                            />
                        </div>
                        <div className="teamanimalnameWinnerscreen">
                            <span className="animalscreenlabelWinnerscreen">
                                {participant.name}
                            </span>
                        </div>
                        <div className="winnerscreen-right">
                            <span className="winnerscreen-score">{participant.score}</span>
                        </div>
                    </div>
                </li>
            ))
        )}
    </ul>
</div>


                    </div>
            
                </Col>
                <Col className="bg-left-right flex-grow-1 flex-shrink-1" />
                
            </Row>
        </Container>
    );
};

export default PlayerWinnerParticipant;
